export default __webpack_public_path__ + "static/media/left.b6deace2.png";